import { AdminAdDTOFields } from '../Types/dto/admin/product'
import { EventInput } from '@fullcalendar/core'

export function isDateHitBooking(
	start: Date | null,
	end: Date | null,
	eventTimes: EventInput[]
): Boolean {
	if (start && end) {
		for (const event of eventTimes) {
			const eventStartTime = new Date(event.start as Date)
			const eventEndTime = new Date(event.end as Date)

			// Check if the start time or end time falls within the range of the current event
			if (eventStartTime <= start && eventEndTime > start) {
				return true
			} else if (eventStartTime < end && eventEndTime >= end) {
				return true
			} else if (eventStartTime >= start && eventEndTime < end) {
				return true
			} else if (eventEndTime > start && eventEndTime <= end) {
				return true
			}
		}
		return false
	} else {
		return false
	}
}
